"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const standard_errors_1 = require("@azavista/standard-errors");
class QueryGenerator {
  _subqueries;
  constructor(_subqueries) {
    this._subqueries = _subqueries;
  }
  generateQuery(queryParams) {
    if (!queryParams || Object.entries(queryParams).length === 0) {
      return this._subqueries.emptySearchQuery;
    }
    const fixed = this._subqueries.fixedSubquery ? [this._subqueries.fixedSubquery] : [];
    return {
      [this._subqueries.andKey]: Object.keys(queryParams).map(key => {
        return this._generateKeyedSubquery(key, queryParams[key]);
      }).concat(fixed)
    };
  }
  _generateKeyedSubquery(key, queryParams) {
    if (key === 'and') {
      return this._generateArraySubquery(this._subqueries.andKey, queryParams);
    }
    if (key === 'or') {
      return this._generateArraySubquery(this._subqueries.orKey, queryParams);
    }
    if (key === 'not') {
      return this._generateArraySubquery(this._subqueries.notKey, [queryParams]);
    }
    if (key === 'id') {
      return this._generateFieldSubquery(this._subqueries.idKey, queryParams);
    }
    return this._generateFieldSubquery(key, queryParams);
  }
  _generateArraySubquery(arrayKey, queryParams) {
    return {
      [arrayKey]: queryParams.map(param => {
        let subquery = {};
        Object.keys(param).forEach(key => {
          const newSubquery = this._generateKeyedSubquery(key, param[key]);
          // To prevent generating loads and loads of nested ands if
          // we can get away with it
          if (Object.keys(newSubquery).every(subkey => {
            return !subquery.hasOwnProperty(subkey);
          })) {
            subquery = {
              ...subquery,
              ...newSubquery
            };
          } else if (subquery.hasOwnProperty(this._subqueries.andKey)) {
            subquery[this._subqueries.andKey].push(newSubquery);
          } else {
            subquery[this._subqueries.andKey] = [newSubquery];
          }
        });
        return subquery;
      })
    };
  }
  _generateFieldSubquery(key, queryParams) {
    if (this._subqueries.allowedFields && !this._subqueries.allowedFields.includes(key)) {
      throw new standard_errors_1.AzavistaError(`Unknown field '${key}' for search`, 'UnknownSearchField');
    }
    let operator;
    if (typeof queryParams !== 'object' || Array.isArray(queryParams) || queryParams === null || queryParams === undefined) {
      // Simple case: equality test
      operator = 'eq';
      queryParams = {
        eq: queryParams
      };
    } else {
      operator = Object.keys(queryParams)[0];
    }
    if (this._subqueries.specialFieldSubqueries && this._subqueries.specialFieldSubqueries.has(key)) {
      return this._subqueries.specialFieldSubqueries.get(key)(key, operator, queryParams[operator], (i, op, val) => this._generateOperatorSubquery(i, op, val));
    }
    return this._generateOperatorSubquery(key, operator, queryParams[operator]);
  }
  _generateOperatorSubquery(key, operator, value) {
    switch (operator) {
      case 'gte':
        return this._subqueries.gteSubquery(key, value);
      case 'lte':
        return this._subqueries.lteSubquery(key, value);
      case 'gt':
        return this._subqueries.gtSubquery(key, value);
      case 'lt':
        return this._subqueries.ltSubquery(key, value);
      case 'after':
        return this._subqueries.afterSubquery(key, value);
      case 'before':
        return this._subqueries.beforeSubquery(key, value);
      case 'in':
        return this._subqueries.inSubquery(key, value);
      case 'not_in':
        return this._subqueries.notInSubquery(key, value);
      case 'like':
        return this._subqueries.likeSubquery(key, value);
      case 'not_like':
        return this._subqueries.notLikeSubquery(key, value);
      case 'eq':
        return this._subqueries.equalsSubquery(key, value);
      case 'not_eq':
        return this._subqueries.notEqualsSubquery(key, value);
      case 'empty':
        return this._subqueries.valueIsEmptySubquery(key, !!value);
      default:
        throw new standard_errors_1.AzavistaError(`Unknown operator ${operator}. How did you even do this?`, 'UnknownOperator');
    }
  }
}
exports.default = QueryGenerator;
